var _defs, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeUncomftorable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1936.99 2001.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffd2c0;\n      }\n\n      .cls-2 {\n        fill: #e59076;\n      }\n\n      .cls-3 {\n        fill: #995222;\n      }\n\n      .cls-4 {\n        fill: #ffbf31;\n      }\n\n      .cls-5 {\n        fill: #7c3108;\n      }\n\n      .cls-6 {\n        fill: #8c3f0a;\n      }\n\n      .cls-7 {\n        fill: #d13737;\n      }\n\n      .cls-8 {\n        fill: #f96d3d;\n      }\n\n      .cls-9 {\n        fill: #6d2e03;\n      }\n\n      .cls-10 {\n        fill: #f2ad97;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 968.49,
    cy: 1000.54,
    rx: 968.49,
    ry: 1000.54
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 959.41,
    cy: 1000.54,
    rx: 830.28,
    ry: 857.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 959.41,
    cy: 1000.54,
    rx: 640.56,
    ry: 661.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 558.83,
    cy: 1190,
    rx: 129.03,
    ry: 133.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 558.83,
    cy: 1190,
    rx: 74.15,
    ry: 76.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1360,
    cy: 1190,
    rx: 129.03,
    ry: 133.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1360,
    cy: 1190,
    rx: 74.15,
    ry: 76.6
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.88,595.54h719.06c23.05,0,41.76,18.71,41.76,41.76v918.92c0,23.05-18.71,41.76-41.76,41.76h-719.06c-23.05,0-41.76-18.71-41.76-41.76v-918.92c0-23.05,18.71-41.76,41.76-41.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M813.91,470.83c.68,220.12-118.49,419.13-299.92,521.12-38.38,21.58-85.5-9.47-81.66-54.44,13.04-152.75,78.76-292.55,182.04-391.01,55.81-53.4,122.56-94.57,197.88-119.31,1.07,14.41,1.66,28.93,1.66,43.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1453.89,955.63c-336.39,179.4-759.3-25.37-839.52-409.14,55.49-53.1,121.81-94.1,196.61-118.89,312.74-104.88,624.39,140.99,671.88,469.61,3.43,23.75-8.31,47.41-28.97,58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1191.85,983.84h0c-58.02,0-115.49-9.28-170.69-27.67-53.75-17.83-104.5-43.9-150.72-77.39-46.04-33.39-86.72-73.45-120.77-119.13-34.78-46.52-62.01-97.84-80.89-152.7-1.64-4.69-1.37-9.76.63-14.26,2.09-4.5,5.72-7.97,10.36-9.66,9.17-3.38,19.88,1.88,23.15,11.35,72.64,210.49,269.12,351.94,488.76,351.94h.18c20.43,0,40.86-1.31,60.75-3.75h0c9.9-1.22,19.06,6.19,20.24,16.32.55,4.97-.73,9.94-3.72,13.88-2.99,3.94-7.35,6.47-12.17,7.04-21.33,2.72-43.31,4.03-65.1,4.03ZM1326.05,965.74c-8.18,0-15.44-5.73-17.52-13.88-2.63-10.04,3.17-20.36,12.79-23.07h.1c1.45-.38,3.09-.56,4.63-.56,8.18,0,15.44,5.62,17.52,13.88,2.63,9.94-3.09,20.17-12.71,22.89,0,.09-.1.09-.1.09-1.54.38-3.17.66-4.72.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1482.86,897.21c-47.49-328.62-359.14-574.49-671.88-469.61-74.8,24.79-141.12,65.79-196.61,118.89,1.49,7.11,3.13,14.14,4.85,21.13,31.58-18.77,65.27-34.39,100.97-46.22,310.63-104.17,620.05,137.73,670.75,463,21.24-8.18,42.27-17.74,62.96-28.78,20.66-11.02,32.4-34.67,28.97-58.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1482.86,897.21c-47.49-328.62-359.14-574.49-671.88-469.61-74.8,24.79-141.12,65.79-196.61,118.89.49,2.34,1.05,4.64,1.57,6.97,44.74-33.91,94.89-60.82,149.65-78.96,312.74-104.88,624.39,140.99,671.88,469.61,1,6.9.58,13.75-.83,20.33,5.78-2.83,11.54-5.75,17.26-8.81,20.66-11.02,32.4-34.67,28.97-58.42Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M813.01,1410.05c-20.5,10.73-43.57-8.92-36.95-31.65,24.46-84,99.91-145.2,189.19-145.2s164.73,61.19,189.19,145.2c6.62,22.73-16.45,42.38-36.95,31.65-101.49-53.1-202.99-53.1-304.48,0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M765.52,1197.29c-4.44,0-8.77-2.34-11.21-6.57-3.69-6.39-1.67-14.66,4.52-18.47l57.24-35.26-57.24-35.26c-6.19-3.81-8.21-12.08-4.52-18.47,3.69-6.39,11.7-8.48,17.88-4.67l76.03,46.83c3.95,2.43,6.36,6.83,6.36,11.57s-2.42,9.14-6.36,11.57l-76.03,46.83c-2.1,1.29-4.4,1.9-6.67,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1164.98,1197.29c-2.27,0-4.57-.61-6.67-1.9l-76.03-46.83c-3.95-2.43-6.36-6.83-6.36-11.57s2.42-9.14,6.36-11.57l76.03-46.83c6.2-3.82,14.19-1.72,17.88,4.67,3.69,6.39,1.67,14.66-4.52,18.47l-57.24,35.26,57.24,35.26c6.19,3.81,8.21,12.08,4.52,18.47-2.44,4.23-6.77,6.57-11.21,6.57Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeUncomftorable);
export default __webpack_public_path__ + "static/media/WE - Uncomftorable.45e100a852fbf42c68ab15877bd35938.svg";
export { ForwardRef as ReactComponent };